// Copyright (c) StrangeBee 2023

import React from 'react';
import { UseQueryResult } from 'react-query';
import { DashboardOutput, WidgetOutput } from 'thehive-sdk';

export interface WidgetQuery {
    widget: WidgetOutput;
    query: UseQueryResult;
}

export interface DashboardContextProps {
    dashboard: DashboardOutput;
    setDashboard: React.Dispatch<React.SetStateAction<DashboardOutput>>;
    editMode: boolean;
    setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
    widgets: WidgetQuery[];
}

export const DashboardContext = React.createContext<DashboardContextProps | undefined>(undefined);
